import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SafeSrcDirective } from './safe-src.directive';

const DIRECTIVES = [SafeSrcDirective];

@NgModule({
  imports: [CommonModule],
  declarations: [...DIRECTIVES],
  exports: [...DIRECTIVES]
})
export class BixiImageModule {
}
